export default "__VITE_ASSET__681ac7d8__"